import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {filter} from 'rxjs';
import {SharedService} from '../../services/common/shared.service';
import {CdsFlavor} from './can-do-statement-panel/can-do-statement-panel.component';

@Component({
  selector: 'app-can-do-statement',
  templateUrl: './can-do-statement.component.html',
  styleUrls: ['./can-do-statement.component.scss'],
  standalone: false
})
export class CanDoStatementComponent implements OnInit {

  selectedTabIndex = 0;

  globalEntryId: number = null;
  globalCategoryId: number = null;
  detailedEntryId: number = null;
  detailedCategoryId: number = null;
  initialSearchQuery: string = null;

  constructor(private route: ActivatedRoute, private router: Router, private sharedService: SharedService) {}

  ngOnInit() {
    this.route.queryParams
      .pipe(filter((params: Params) => !!params['id'] || !!params['c_id'] || !!params['q']))
      .subscribe((params: Params) => {
        if (params['q']) {
          this.initialSearchQuery = params['q'];
        }
        const flavor: CdsFlavor = params['flavor'] === 'detailed' ? 'detailed' : 'global';
        this.selectedTabIndex = flavor === 'detailed' ? 1 : 0;
        if (flavor === 'detailed') {
          this.detailedEntryId = params['id'] ? Number(params['id']) : null;
          this.detailedCategoryId = params['c_id'] ? Number(params['c_id']) : null;
        } else {
          this.globalEntryId = params['id'] ? Number(params['id']) : null;
          this.globalCategoryId = params['c_id'] ? Number(params['c_id']) : null;
        }
        this.sharedService.clearIdParam(this.router);
      });
  }
}
